import React from 'react';
import { motion } from 'framer-motion';

export const HistoryStrip = ({ items, onSelect, selectedIndex, isVertical = false }) => {
  if (items.length === 0) return null;

  const containerClass = isVertical
    ? 'flex flex-col gap-2 p-2'
    : 'flex gap-2 p-3 overflow-x-auto scrollbar-hide';

  return (
    <motion.div
      initial={{ opacity: 0, y: isVertical ? 0 : 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={containerClass}
    >
      {items.map((item, index) => (
        <motion.button
          key={item.id || index}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.05 }}
          onClick={() => onSelect(index)}
          className={`relative flex-shrink-0 ${isVertical ? 'w-14 h-14' : 'w-12 h-12'} rounded-lg overflow-hidden border-2 transition-all ${
            selectedIndex === index
              ? 'border-blue-500 shadow-md scale-105'
              : 'border-transparent opacity-70 hover:opacity-100'
          }`}
        >
          <img src={item.thumbnail || item.url} alt="" className="w-full h-full object-cover" />
          {item.type === 'customer_photo' && (
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-600/90 to-transparent py-0.5">
              <span className="text-[8px] text-white font-medium block text-center">You</span>
            </div>
          )}
          {item.type === 'moment' && (
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-purple-600/90 to-transparent py-0.5">
              <span className="text-[8px] text-white font-medium block text-center">✨</span>
            </div>
          )}
        </motion.button>
      ))}
    </motion.div>
  );
};
